// extracted by mini-css-extract-plugin
export default {"controls":"CommentEdit_controls__G6+3g","field":"CommentEdit_field__lrjjA"};